// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"167":"d5506b24","623":"23a72ae4","785":"8728f628","906":"aad1cc4b"}[chunkId] + ".js";
};